import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  REF_STORAGE_KEY,
  extractRefIdFromSearch,
} from "components/Profile/ProfileReferals/helpers";

// Capture a `?ref=<inviter users.id>` link at app load (Phase 4). The id is
// persisted so it survives the navigation to the sign-up form, where it is sent
// as `ref_id` and then cleared (see SignInForm).
//
// A link opened by an already-registered / logged-in visitor changes nothing:
// we gate on the presence of an api_key in localStorage (set at login/signup),
// which is reliable at load time regardless of the async auth-init race.
export const useReferralCapture = () => {
  const { search } = useLocation();

  useEffect(() => {
    const refId = extractRefIdFromSearch(search);
    if (refId === null) return;

    // Logged-in user (api_key present) → ignore the referral param entirely.
    if (localStorage.getItem("api_key")) return;

    localStorage.setItem(REF_STORAGE_KEY, String(refId));
  }, [search]);
};
